import { t as throttle } from './throttle-C-vewrHK.js';
import './debounce-Dg7s1ivP.js';

class JewelerSearch extends HTMLElement {
  connectedCallback() {
    this.jewelerList = document.querySelector('jeweler-list');

    // Store the search input and add input event listener
    this.searchInput = this.querySelector('input[type="search"]');
    this.searchInput.addEventListener(
      'input',
      throttle((event) => this.handleSearch(event), 500)
    );

    // Store the owned store checkbox and add change event listener
    this.searchOwnedStore = this.querySelector('input#jeweler-filter-bron-boutique');
    this.searchOwnedStore?.addEventListener('change', (event) => this.handleOwnedStore(event));

    // Store all country checkboxes and add change event listener
    this.searchCountries = Array.from(this.querySelectorAll('input[type="checkbox"]')).filter(
      (country) => country.id !== 'jeweler-filter-bron-boutique'
    );
    this.searchCountries?.forEach((country) => {
      country.addEventListener('change', () => this.handleCountries());
    });

    // Store reserve buttons and add click event listener
    this.reserveButtons = this.jewelerList.querySelectorAll('[data-reserve-button]');
    this.reserveButtons?.forEach((button) => {
      button.addEventListener('click', (event) => this.handleReserve(event));
    });
  }

  handleSearch({ target }) {
    // Set the q attribute on the jeweler-list element
    this.jewelerList.setAttribute('query', target.value);
  }

  handleOwnedStore({ target }) {
    // Set the owned attribute on the jeweler-list
    this.jewelerList.setAttribute('owned-store', target.checked);
  }

  handleCountries() {
    // Get all checked countries
    const countries = Array.from(this.searchCountries)
      .filter((country) => country.checked)
      .map((country) => country.value);

    // Set the country attribute on the jeweler-list
    this.jewelerList.setAttribute('countries', countries);
  }

  handleReserve({ currentTarget }) {
    const { jewelerId } = currentTarget.closest('.jeweler-info-card').dataset;

    // Find the matching jeweler in this.jewelerList.jewelers and store it in the session storage
    this.jewelerList.jewelers.find((jeweler) => {
      if (jeweler.id === jewelerId) {
        sessionStorage.setItem('reservedJeweler', JSON.stringify(jeweler));
        return (window.location = currentTarget.dataset.stepTwoUrl);
      }
    });
  }
}

if (!customElements.get('jeweler-search')) {
  customElements.define('jeweler-search', JewelerSearch);
}
